/**
 * ClientConfig の型と Context だけを分離（Provider と hooks は別ファイル）。
 */
import { createContext } from "react";

export type Competitor = {
  name: string;
  monitoringSource?: string;
  primary?: boolean;
};

export type ClientConfig = {
  clientId: string;
  displayName: string;
  companyDisplayName: string;
  industryLabel?: string;
  competitors: Competitor[];
  aiPromptTemplates: string[];
  slack: {
    workspace?: string;
    queryChannelId?: string;
    hitlApprovalChannelId?: string;
    systemChannelId?: string;
    dailyChannelId?: string;
    weeklyChannelId?: string;
  };
  branding?: {
    accent?: "green" | "ink";
    faviconEmoji?: string;
  };
  sampleKpiContext?: {
    primaryTargetGrade?: string;
    keyLandingPages?: string[];
  };
  studio?: {
    /** 自社サイトの正となる URL。Studio フォームの site_design_url 既定値 */
    siteDesignUrl?: string;
    /** ブランドカラー hex 配列（primary/secondary/accent の順）*/
    brandColors?: string[];
    /** Studio フォームのペルソナ chip 候補 */
    personas?: { id: string; label: string }[];
  };
};

export const FALLBACK_CLIENT_CONFIG: ClientConfig = {
  clientId: "unknown",
  displayName: "Centurio Axis",
  companyDisplayName: "",
  competitors: [],
  aiPromptTemplates: [
    "このレポートの内容で気になる点は？",
    "直近の KPI で特に見ておくべき変動は？",
  ],
  slack: {},
};

export const ClientConfigContext = createContext<ClientConfig>(FALLBACK_CLIENT_CONFIG);
